(() => {
  const params = new URLSearchParams(window.location.search);
  const shouldAutoOpen = params.has("open_chat") || params.has("chat");
  let hasAutoOpened = false;

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0";
  };

  const findToggleButton = () => {
    const selectors = [
      'button[data-spec="toggle-button"]',
      "button.chat-toggle",
      ".chat-toggle",
      "#shopify-chat button[data-spec='toggle-button']",
    ];

    for (const selector of selectors) {
      const button = document.querySelector(selector);
      if (!button) continue;
      if (button.getAttribute("name") === "closeChat") continue;
      if (isVisible(button)) return button;
    }

    return null;
  };

  const isChatOpen = () =>
    Boolean(document.querySelector("#chat-ui")) ||
    Boolean(document.querySelector(".chat-ui")) ||
    Boolean(document.querySelector('button[name="closeChat"]'));

  const stripChatParamsFromUrl = () => {
    const current = new URL(window.location.href);
    if (!current.searchParams.has("open_chat") && !current.searchParams.has("chat")) return;
    current.searchParams.delete("open_chat");
    current.searchParams.delete("chat");
    window.history.replaceState({}, "", current.toString());
  };

  const tryOpenChat = () => {
    if (isChatOpen()) {
      stripChatParamsFromUrl();
      return true;
    }

    const toggleButton = findToggleButton();
    if (!toggleButton) return false;

    toggleButton.click();
    if (isChatOpen()) {
      stripChatParamsFromUrl();
      return true;
    }

    return false;
  };

  const openWithRetry = () => {
    if (hasAutoOpened) return;

    let attempts = 0;
    const maxAttempts = 48;
    const interval = window.setInterval(() => {
      attempts += 1;
      const opened = tryOpenChat();
      if (opened || attempts >= maxAttempts) {
        window.clearInterval(interval);
        if (opened) hasAutoOpened = true;
      }
    }, 250);
  };

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest("a[href]");
    if (!anchor) return;

    let url;
    try {
      url = new URL(anchor.getAttribute("href"), window.location.href);
    } catch (_error) {
      return;
    }

    const isShopLink = url.origin === window.location.origin || url.origin === "https://shop.waterdoctor.ca";
    const wantsChat = url.searchParams.has("open_chat") || url.searchParams.has("chat");
    if (!isShopLink || !wantsChat) return;

    event.preventDefault();
    const opened = tryOpenChat();
    if (opened) return;

    window.setTimeout(() => {
      window.location.href = url.toString();
    }, 600);
  });

  window.WaterDoctorChat = {
    open: openWithRetry,
  };

  if (!shouldAutoOpen) return;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openWithRetry, { once: true });
  } else {
    openWithRetry();
  }

  window.addEventListener("load", () => {
    if (!hasAutoOpened) openWithRetry();
  });
})();
